import { Injectable } from '@angular/core';
import { PscHttpService } from "./psc-http.service";
import { UpdateProfileDto } from "../common/models/user/update-profile-dto";
import { map, mergeMap } from "rxjs";
import { User } from "../common/models/user";
import { SKIP_STATUS_CODES } from "../common/interceptors/error-response-handler.interceptor";
import { HttpContext } from "@angular/common/http";
import { UserRole } from '../common/models/user/user-role.enum';
import { RegisterRequest } from '../common/models/auth/register-request';
import { AuthService } from './auth/auth.service';

@Injectable({
  providedIn: 'root',
})
export class UserService {

  baseEndpoint = 'users/';

  constructor(
    private httpService: PscHttpService,
    private authService: AuthService,
  ) {
  }


  register(registerRequest: RegisterRequest) {
    return this.httpService.post(`${ this.baseEndpoint }registration`, registerRequest,
      {
        context: new HttpContext().set(SKIP_STATUS_CODES, [409]),
      });
  }

  getCurrentUserDetails() {
    return this.httpService.get(`${ this.baseEndpoint }me`).pipe(
      map(userData => userData as unknown as User),
    );
  }

  updateCurrentUser(body: UpdateProfileDto) {
    return this.httpService.put(`${ this.baseEndpoint }`, body).pipe(
      mergeMap(() => this.authService.userCheck()),
    );
  }

  passwordChange(newPassword: string) {
    return this.httpService.put(`${ this.baseEndpoint }password`, { password: newPassword });
  }

  forgotPassword(email: string) {
    return this.httpService.post(`${ this.baseEndpoint }forgot-password`,
      { email }, {
        context: new HttpContext().set(SKIP_STATUS_CODES, [404]),
      });
  }

  confirmPasswordReset(userId: string, confirmationToken: string, password: string) {
    return this.httpService.post(`${ this.baseEndpoint }confirm-reset`, { userId, confirmationToken, password });
  }

  confirmRegistration(userId: string, confirmationToken: string) {
    return this.httpService.post(`${ this.baseEndpoint }confirm`, { userId, confirmationToken });
  }
  getAllUsers() {
    return this.httpService.get(`${ this.baseEndpoint }`).pipe(
      map(users => users as User[]),
    );
  }

  updateUser(userId: string, newRole: UserRole, subscriptionExpiry: Date) {
    return this.httpService.put(`${ this.baseEndpoint }${ userId }`, {
      subscriptionExpiry,
      roles: [newRole],
    });
  }


  deleteUser(userId: string) {
    return this.httpService.delete(`${ this.baseEndpoint }${ userId }`);
  }

}
